module.exports = __webpack_public_path__ + "img/TJ.37255c9f.svg";